// Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../wipe-dark.png'; // Import your logo image
import { useAuth } from '../AuthContext';
import {
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  StatArrow,
  StatGroup,
  Card,
  useColorModeValue,
  CardBody,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Spinner,
  Image,
  Text,
  Box,
} from '@chakra-ui/react';
const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async () => {
    if (username && password) {
      try {
        const response = await fetch('https://api.wipe.wtf/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: username,
            password: password,
          }),
        });

        if (response.ok) {
          const data = await response.json();
          if (data.accessToken) {
            // Save the access token and set authenticated state to true
            login(data.accessToken);
            navigate('/');
          } else {
            alert('Login failed. Please try again.');
          }
        } else {
          alert('Login failed. Please try again.');
        }
      } catch (error) {
        console.error('Login error:', error);
        alert('Login failed. Please try again later.');
      }
    } else {
      alert('Please enter a valid username and password.');
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: useColorModeValue('#fff', '#0b0b0b'),
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <img
        src={useColorModeValue(
          require('../wipe-light.png'),
          require('../wipe-dark.png')
        )}
        alt="Logo"
        style={{
          width: '90px',
          height: '90px',
          position: 'absolute',
          top: '10px',
          left: '25px',
        }}
      />
      <div
        style={{
          textAlign: 'center',

          margin: 'auto',
          width: '360px',
          backgroundColor: useColorModeValue(
            'rgba(31, 31, 31, 0.8)',
            'rgba(31, 31, 31, 0.8)'
          ),
          padding: '35px',
          paddingTop: '40px',
          paddingBottom: '40px',
          borderRadius: '25px',
          backdropFilter: 'blur(20px)',
          boxShadow: '0px 0px 20px rgba(9, 9, 9, 0.3)',
        }}
      >
        <div
          style={{
            textAlign: 'left',

            width: '270px',
            margin: 'auto',
          }}
        >
          <div style={{ width: '100%', marginBottom: '20px' }}>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={e => setUsername(e.target.value)}
              style={{
                width: '100%',
                padding: '15px',
                height: 45,
                borderRadius: '15px',
                border: '1px solid #ccc',
                fontSize: 13,
                marginBottom: '10px',

                boxSizing: 'border-box',
              }}
            />
          </div>
          <div style={{ width: '100%', marginBottom: '20px' }}>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              style={{
                width: '100%',
                padding: '15px',
                borderRadius: '15px',
                height: 45,
                fontSize: 13,

                border: '1px solid #ccc',
                marginBottom: '10px',
                boxSizing: 'border-box',
              }}
            />
          </div>
          <div>
            <button
              onClick={handleLogin}
              style={{
                backgroundColor: '#0c0c0c',
                color: '#fff',
                padding: '15px',
                borderRadius: '15px',
                border: 'none',
                cursor: 'pointer',
                fontSize: 13,
                fontWeight: 'bold',
                width: '100%',
                boxSizing: 'border-box',
              }}
            >
              Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
